export const environment = {
    production: true,
    msalConfig: {
        auth: {
            clientId: 'f21958fc-8d18-4109-944f-59a2d10756ab',
            authority: 'https://login.microsoftonline.com/46c5178e-a0f4-4f4d-8c40-9598e3d11860',
        }
    },
    graphApiConfig:{
        scopes: ['user.read'],
        uri: 'https://graph.microsoft.com/v1.0/me'
    },
    apiConfig: {
        uri: 'https://cw-va-api-prod.azurewebsites.net/', // your API base URL
        scopes: [
            'api://6c6bb33d-b8ce-4e7a-ac3f-5ba093a0f628/access_as_user' // backend API scope
        ]
    },
    apiBaseUrl: 'https://cw-va-api-prod.azurewebsites.net',
    appraisalApiConfig:{
        baseUrl: 'https://cw-va-api-prod.azurewebsites.net/api/v1/appraisal'
    },
    argusApiConfig:{
        baseUrl: 'https://cw-va-api-prod.azurewebsites.net'
    },
    bookmarksApiConfig:{
        baseUrl: 'https://cw-va-api-prod.azurewebsites.net/api/v1/bookmarks'
    },
    ratingsApiConfig:{
        baseUrl: 'https://cw-va-api-prod.azurewebsites.net/api/v1'
    },
    signalRConfig: {
        hubUrl: 'https://cw-va-api-prod.azurewebsites.net/hubs/grid-refresh',
        refreshEvents: ['AppraisalUpdated'],
        pollingIntervalMs: 10000
    }
};